import * as React from "react";

import { formatCurrency } from "app/utils/filters";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";

const columnConfigs: ColumnConfig[] = [
  {
    name: "User",
    render: row => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/users/${
          row.device.user.external_reference
        }/payments`}
        snapminUrl={row.device.user.snapmin_url}
      >
        {row.device.user.email}
      </BackOfficeAndSnapminLink>
    )
  },
  {
    name: "Merchant",
    render: row => {
      return (
        <BackOfficeAndSnapminLink
          backofficeUrl={`/snapscan/ops/merchants/${row.merchant.id}/payments`}
          snapminUrl={row.merchant.snapmin_url}
        >
          {row.merchant.name}
        </BackOfficeAndSnapminLink>
      );
    }
  },
  {
    name: "Device",
    render: row => {
      return (
        <BackOfficeAndSnapminLink
          backofficeUrl={`/snapscan/ops/devices/${
            row.device.external_reference
          }/summary`}
          snapminUrl={row.device.snapmin_url}
        >
          {row.device.phone_number || "-"}
        </BackOfficeAndSnapminLink>
      );
    }
  },
  {
    name: "Payable amount",
    cellProps: { align: "right" },
    render: row => `R${formatCurrency(row.payable_amount)}`
  }
];

export default columnConfigs;
